var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFamilyResponsabilityIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3327 18.6665C19.0987 18.6665 21.3324 20.9185 21.3327 23.686V25.6665C21.3327 26.2188 20.8849 26.6665 20.3327 26.6665H3.66602C3.11374 26.6665 2.66602 26.2188 2.66602 25.6665V23.686C2.66628 20.9185 4.90006 18.6665 7.66602 18.6665H16.3327Z",
    fill: "#DB443A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3327 18.6665C27.0987 18.6665 29.3325 20.9185 29.3327 23.686V25.3332C29.3327 26.0696 28.7358 26.6665 27.9994 26.6665H23.3327V23.686L23.3237 23.3253C23.2314 21.5057 22.4462 19.8645 21.2246 18.6665H24.3327Z",
    fill: "#DB443A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.3335C15.3137 5.3335 18 8.01979 18 11.3335C18 14.6472 15.3137 17.3335 12 17.3335C8.68629 17.3335 6 14.6472 6 11.3335C6 8.01979 8.68629 5.3335 12 5.3335Z",
    fill: "#DB443A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.3335C23.3137 5.3335 26 8.01979 26 11.3335C26 14.6472 23.3137 17.3335 20 17.3335C19.727 17.3335 19.4586 17.3128 19.1953 17.2775C18.7572 17.0806 18.2946 16.928 17.8138 16.8244C19.1676 15.3914 20 13.4604 20 11.3335C20 9.1714 19.1398 7.21206 17.7461 5.7723C18.4421 5.48994 19.2026 5.3335 20 5.3335Z",
    fill: "#DB443A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyResponsabilityIcon);
export default __webpack_public_path__ + "static/media/family_responsability_icon.5201e0ff9fc5669370eab0bd3b17d447.svg";
export { ForwardRef as ReactComponent };